import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useGetUserProfileQuery } from "../rtk-query/slices/profile/profileSlice";
import { toast } from "react-toastify";

function CreateProductBtn({ isHide = true }) {
  const navigate = useNavigate();
  const { data: userProfile } = useGetUserProfileQuery();

  const loc = window.location.href;
  let canClickable =
    userProfile?.data?.supplier?.status === "Approved" ? true : false;

  const handleLinkClick = () => {
    if (!canClickable) {
      toast.warn("Your profile is under review. Please wait for approval.");
    }
  };
  return (
    <Button
      variant="outline-primary"
      className={`mr-2 ${
        isHide ? "d-none d-lg-flex" : "d-flex"
      } dod-dash-header-create-btn`}
      onClick={(e) => {
        e.preventDefault();
        if (!loc.includes("create-product")) {
          localStorage.removeItem("productId");
        }
        if (canClickable) {
          navigate("/create-product");
        } else {
          handleLinkClick();
        }
      }}
    >
      + Create a product
    </Button>
  );
}

export default CreateProductBtn;
